/**
 *
 * Ask
 *
 */

import Swal from 'sweetalert2';

export const QaSwalMixin = {
  name: 'QaSwalMixin',

  data: () => {
    return {};
  },

  methods: {
    async swalPostQAFailure(text) {
      await Swal.fire({
        width: '400px',
        backdrop: false,
        type: 'warning',
        icon: 'warning',
        title: '问答失败',
        text,
        showConfirmButton: true,
        timer: 3000,
      });
    },

    async swalNotCanPostQA() {
      await this.swalPostQAFailure('很抱歉，您当前的班型不能在有问必答里进行提问或者回答。');
    },

    async swalPostQASuccess() {
      await Swal.fire({
        width: '400px',
        backdrop: false,
        type: 'success',
        icon: 'success',
        title: '问答已经发布',
        showConfirmButton: false,
        timer: 3000,
      });
    },
  },
};

export default QaSwalMixin;
